import { PromotionType } from '~/lib/data-contract/salesforce';
import { PriceLike } from '~/lib/salesforce/types';
import { PriceTypes } from '~/shared/components/ProductCard/components/Price';

/**
 * Christmas/Super prices used to arrive as a single `default` row that FE paints red.
 * When SFCC also sends a separate `sale` row (promo + before), only the sale row should be red.
 */
export const shouldHighlightDefaultPromoPrice = ({
    priceType,
    promoType,
    prices,
}: {
    priceType?: string;
    promoType?: string | null;
    prices: PriceLike[];
}): boolean => {
    const isChristmasOrSuper =
        promoType === PromotionType.CHRISTMAS_PRICE || promoType === PromotionType.SUPER_PRICE;

    if ((priceType || PriceTypes.DEFAULT) !== PriceTypes.DEFAULT || !isChristmasOrSuper) {
        return false;
    }

    const hasSeparateSalePrice = prices.some(
        (price) => (price.type || PriceTypes.DEFAULT) === PriceTypes.SALE,
    );

    return !hasSeparateSalePrice;
};
